import { all } from 'redux-saga/effects'
import { sagas as authSaga } from '../containers/Auth/store'
import { sagas as searchSaga } from '../containers/Search/store'

export default function* rootSaga() {
  yield all([
    authSaga(),
    searchSaga()
  ])
}



// WEBPACK FOOTER //
// ./src/store/rootSagas.js